import { render, staticRenderFns } from "./shopcase.vue?vue&type=template&id=39197402&scoped=true&"
import script from "./shopcase.vue?vue&type=script&lang=js&"
export * from "./shopcase.vue?vue&type=script&lang=js&"
import style0 from "./shopcase.vue?vue&type=style&index=0&id=39197402&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39197402",
  null
  
)

export default component.exports